import React, { createContext, useState } from 'react';

// Set context with default value of null -> The context is used to retrieve all information from the provider
export const GlobalContext = createContext(null);

export const GlobalProvider = (props) => {
    const getApySrc = () => {
        if (typeof window !== 'undefined') {
            const array = window.location.search.replaceAll('?', '').split('&');
            let res;
            array.forEach((str) => {
                const strArray = str.split('=');
                const apySrcIndex = strArray.indexOf('apy_src');

                if (apySrcIndex >= 0) {
                    res = strArray[apySrcIndex + 1];
                }
            });

            return res;
        }
        return undefined
    };

    const [globalValue, setGlobalValue] = useState({
        theme: 'default',
        menuState: false,
        modalIsOpen: false,
        signup_modal_open: false,
        newsletterModalIsOpen: false,
        videoModalIsOpen: false, // TODO: Change to false
        mainBookingModalIsOpen: false,
        howDoesItWorkModalIsOpen: false,
        privacyModalIsOpen: false,
        insuranceModalIsOpen: false,
        landboatModalIsOpen: false,
        costOfTherapyModal: false,
        miniInsuranceModal: false,
        paymentInfoModalIsOpen: false,
        whyAuswahlModalIsOpen: false,
        whyReferralInviteModalIsOpen: false,
        whatIsCoachingModalIsOpen: false,
        prepareInfoCallModalIsOpen: false,
        limitationOfCoachingModalIsOpen: false,
        promoteVoucherModalIsOpen: false,
        insuranceCheckerSwiper: null,
        audioState: false,
        audioObj: null,
        avatarAudioWrapper: null,
        hasAnnouncement: false,
        apySrc: getApySrc()
    });

    return (
        <GlobalContext.Provider value={[globalValue, setGlobalValue]}>
            {props.children}
        </GlobalContext.Provider>
    );
};
